import { makeVar } from "@apollo/client";
import { ChannelType, RoomStatus } from "~@/graphql/codegen/generated";
import { channelsTypes, chatsTypes } from "~@/readonly-variables";

// Хранилище для выбранных типов каналов. Изначально содержит все доступные типы каналов.
export const selectedChannelsTypesVar = makeVar<ChannelType[]>([
  ...channelsTypes,
]);

// Хранилище для выбранного типа чата. Изначально содержит первый статус из доступных статусов чатов.
export const selectedChatsTypeVar = makeVar<RoomStatus>(chatsTypes[0]);

// Хранилище для идентификаторов избранных фрагментов. Изначально пустой массив.
export const favoritesSnippetsIdsVar = makeVar<string[]>([]);

// Хранилище для фильтрации категорий шаблонов. Изначально пустая строка.
export const snippetsCategoriesFilterVar = makeVar<string>("");

// Хранилище для идентификаторов новых комнат. Изначально пустой массив.
export const newRoomsIdsVar = makeVar<string[]>([]);

// Хранилище для информации о завершении онбординга. Значение извлекается из localStorage.
export const isOnboardingFinishedVar = makeVar<boolean>(
  Boolean(parseInt(localStorage.getItem("isOnboardingFinished") ?? "0"))
);

// Хранилище для unread count notifications. Изначально пустой массив.
export const unreadNotificationsCountVar = makeVar<number>(0);
